var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Model",
    {
      attrs: {
        "is-show": _vm.isVisible,
        "dialog-status": _vm.$t("navbar.changeRole"),
        "save-item": _vm.changeRole,
        width: "500px",
      },
      on: {
        "update:isShow": function ($event) {
          _vm.isVisible = $event
        },
        "update:is-show": function ($event) {
          _vm.isVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { attrs: { size: "medium", inline: "", "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("login.selectRole") } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("login.selectRolePlaceholder") },
                  model: {
                    value: _vm.role,
                    callback: function ($$v) {
                      _vm.role = $$v
                    },
                    expression: "role",
                  },
                },
                _vm._l(_vm.roleList, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: _vm.getRoleName(item), value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }